// extracted by mini-css-extract-plugin
module.exports = {"card":"_3beu6kD1esjXjdSnAKMpnn","image":"_3KwHulhvNV4dVEZASTwCyR"};